import { setCookie } from '@cian/utils/lib/browser/cookie';

export const STALKER_BANNER_COOKIE = 'serp_stalker_banner';

export function setStalkerBannerCookie() {
  const cookieConfig = {
    secure: false,
    expires: 3600 * 24 * 10,
  };

  setCookie(STALKER_BANNER_COOKIE, '1', cookieConfig);
}
